"use client";

import { c as _c } from "react/compiler-runtime";
import { LoadMoreCommentsButton } from "@/components/Comment/components/list/LoadMoreCommentsButton.component";
import { CommentThread } from "@/components/Comment/components/thread/CommentThread.component";
import { useComments } from "@/components/Comment/context/comments.context";
export function CommentsList() {
  const $ = _c(7);
  const {
    state: t0
  } = useComments();
  const {
    comments,
    pagination
  } = t0;
  const hasMoreToLoad = pagination.hasNextPage && pagination.endCursor !== null;
  let t1;
  if ($[0] !== comments) {
    t1 = comments.map(_temp);
    $[0] = comments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== hasMoreToLoad) {
    t2 = hasMoreToLoad ? <div className="mt-6 flex justify-center border-smoke border-t pt-4"><LoadMoreCommentsButton /></div> : null;
    $[2] = hasMoreToLoad;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div aria-label="Comments list" aria-live="polite" role="feed">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(comment) {
  return <CommentThread comment={comment} key={comment.id} />;
}